<!--  -->
<template>
  <div class="historypage">
    <div align="center">
      <div id="DomPdf" style="width:1000px; border:1px solid #000000; padding: 45px 57px; box-sizing: border-box;">
        <el-row class="title">
          <el-col :span="6">
            <div class="blank"></div>
          </el-col>
          <el-col :span="12">
            <span style="text-align: center; display:inline-block; font-size: 24px;">动态血糖检测报告</span>
          </el-col>
          <el-col :span="6">
            <img crossorigin="anonymous" style="width:110px" src="../../../../../public/img/logo_xingou.png" />
          </el-col>
        </el-row>

        <hr style="height:2px;border:none;border-top:7px double gray;margin-top: 2px;" />

        <el-row class="info" style="margin-bottom: 10px;">
          <el-col :span="5">
            <span style="text-align: center; display:inline-block; font-size: 16px;">姓名：{{ realName }}</span>
          </el-col>
          <el-col :span="5">
            <span style="text-align: center; display:inline-block; font-size: 16px;">性别：{{ gender === 1 ? '男' : '女' }}</span>
          </el-col>
          <el-col :span="5">
            <span style="text-align: center; display:inline-block; font-size: 16px;">年龄：{{ age }}</span>
          </el-col>
          <el-col :span="9">
            <span style="text-align: center; display:inline-block; font-size: 16px;">时间：{{ time }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="10" style="margin-bottom: 16px;" v-if="hasSummary">
          <el-col :span="6">
            <div class="stat-card glucose-card">
              <div class="stat-title">最新血糖</div>
              <div class="stat-main">{{ showValue(latestGlucose) }}<span class="stat-unit">mmol/L</span></div>
              <div class="stat-sub">平均 {{ showValue(avgGlucose) }} mmol/L</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card range-card">
              <div class="stat-title">血糖范围</div>
              <div class="stat-main">{{ showValue(minGlucose) }}-{{ showValue(maxGlucose) }}</div>
              <div class="stat-sub">最低/最高 mmol/L</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card tir-card">
              <div class="stat-title">达标时间占比 (TIR)</div>
              <div class="stat-main">{{ showPercent(report && report.tir) }}</div>
              <div class="stat-sub">GMI {{ showValue(report && report.gmi) }} | CV {{ showPercent(report && report.cv) }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card device-card">
              <div class="stat-title">监测状态</div>
              <div class="stat-main status-main">{{ statusName }}</div>
              <div class="stat-sub">采样点 {{ sampleCount }} 个</div>
            </div>
          </el-col>
        </el-row>

        <div v-loading="loadingChart" element-loading-text="数据加载中">
          <div style="text-align: left; font-size: 15px; font-weight: bold; margin-bottom: 4px; color: #4da1eb;">
            血糖值趋势
          </div>
          <div id="glucoseChart" style="width: 100%; height: 300px;"></div>

          <div style="text-align: left; font-size: 15px; font-weight: bold; margin: 12px 0 4px; color: #67C23A;">
            报告区间占比
          </div>
          <div id="rangeChart" style="width: 100%; height: 220px;"></div>
        </div>

        <div v-if="record" style="text-align: left; margin-top: 12px; font-size: 14px; color: #666;">
          监测时长：{{ totalTime }} &nbsp;&nbsp;
          设备SN：{{ record.deviceSn || '--' }} &nbsp;&nbsp;
          第{{ record.theDay || '--' }}天
        </div>

        <div v-if="report" class="report-info" v-loading="loadingReport" element-loading-text="报告加载中">
          <el-row :gutter="10">
            <el-col :span="6">报告日期：{{ report.beginDate || '--' }} 至 {{ report.endDate || '--' }}</el-col>
            <el-col :span="5">有效天数：{{ report.dayNum || '--' }}</el-col>
            <el-col :span="5">平均血糖：{{ showValue(report.meanValue) }} mmol/L</el-col>
            <el-col :span="5">文件：{{ report.fileName || '--' }}</el-col>
            <el-col :span="3" style="text-align: right;">
              <el-button v-if="report.filePath" type="primary" size="mini" plain @click="openReport">查看PDF</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: '',
      totalTime: '',
      realName: '',
      gender: '',
      age: '',
      uid: '',
      id: '',
      record: null,
      routeRecord: {},
      report: null,
      samples: [],
      loadingChart: true,
      loadingReport: false,
      glucoseChart: null,
      rangeChart: null,
      resizeHandler: null,
    };
  },
  computed: {
    hasSummary() {
      return !!(this.record || Object.keys(this.routeRecord).length || this.samples.length || this.report);
    },
    sampleValues() {
      return (this.samples || [])
        .map(item => this.toNumber(item.value))
        .filter(value => value !== null);
    },
    latestGlucose() {
      const latestSample = this.sampleValues.length ? this.sampleValues[this.sampleValues.length - 1] : null;
      return this.pickNumber('latestValue', latestSample);
    },
    avgGlucose() {
      const sampleAvg = this.sampleValues.length
        ? Number((this.sampleValues.reduce((sum, value) => sum + value, 0) / this.sampleValues.length).toFixed(1))
        : null;
      return this.pickNumber('avgValue', this.report && this.report.meanValue, sampleAvg);
    },
    minGlucose() {
      const sampleMin = this.sampleValues.length ? Math.min.apply(null, this.sampleValues) : null;
      return this.pickNumber('minValue', sampleMin);
    },
    maxGlucose() {
      const sampleMax = this.sampleValues.length ? Math.max.apply(null, this.sampleValues) : null;
      return this.pickNumber('maxValue', sampleMax);
    },
    sampleCount() {
      if (this.samples.length > 0) return this.samples.length;
      const count = this.pickNumber('sampleCount');
      return count === null ? 0 : count;
    },
    statusName() {
      const status = this.pickNumber('status');
      if (status === 1) return '监测中';
      if (status === 2) return '已结束';
      return '--';
    },
  },
  methods: {
    toNumber(value) {
      if (value === null || value === undefined || value === '' || value === '--') return null;
      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? null : numberValue;
    },
    pickNumber(field, fallback1, fallback2) {
      const candidates = [
        this.record && this.record[field],
        this.routeRecord && this.routeRecord[field],
        fallback1,
        fallback2,
      ];
      for (let i = 0; i < candidates.length; i++) {
        const value = this.toNumber(candidates[i]);
        if (value !== null) return value;
      }
      return null;
    },
    showValue(value) {
      return value === null || value === undefined ? '--' : value;
    },
    showPercent(value) {
      if (value === null || value === undefined) return '--';
      return value + '%';
    },
    formatDuration(seconds) {
      seconds = Number(seconds) || 0;
      let d = Math.floor(seconds / 86400);
      let h = Math.floor((seconds % 86400) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let s = seconds % 60;
      if (d > 0) return d + '天' + h + '小时' + m + '分';
      if (h > 0) return h + '小时' + m + '分';
      if (m > 0) return m + '分' + s + '秒';
      return s + '秒';
    },
    getDetail() {
      this.loadingChart = true;
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodglucose/app/detail'),
        method: 'get',
        params: this.$http.adornParams({ id: this.id }),
      }).then(({ data }) => {
        this.loadingChart = false;
        if (data && data.code === 0) {
          const payload = data.data || {};
          this.record = {
            ...this.routeRecord,
            ...(payload.record || data.record || {}),
          };
          this.samples = payload.samples || payload.sampleList || data.samples || data.sampleList || [];
          if (this.record && this.record.duration) {
            this.totalTime = this.formatDuration(this.record.duration);
          }
          this.$nextTick(() => {
            this.drawGlucoseChart();
            this.drawRangeChart();
          });
        } else {
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.loadingChart = false;
        this.$message.error('数据加载失败');
      });
    },
    getReport() {
      this.loadingReport = true;
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodglucose/app/report'),
        method: 'get',
        params: this.$http.adornParams({ recordId: this.id }),
      }).then(({ data }) => {
        this.loadingReport = false;
        if (data && data.code === 0) {
          this.report = data.data || null;
          this.$nextTick(() => {
            this.drawRangeChart();
          });
        }
      }).catch(() => {
        this.loadingReport = false;
      });
    },
    drawGlucoseChart() {
      const dom = document.getElementById('glucoseChart');
      if (!dom) return;
      if (this.glucoseChart) this.glucoseChart.dispose();
      this.glucoseChart = this.$echarts.init(dom);

      const timeList = this.samples.map(s => s.sampleTime);
      const valueList = this.samples.map(s => s.value);
      const labelInterval = Math.max(0, Math.ceil(timeList.length / 12) - 1);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            const p = params[0];
            return `时间：${p.axisValue}<br/>血糖：${p.value} mmol/L`;
          },
        },
        toolbox: {
          feature: {
            dataZoom: { yAxisIndex: 'none' },
            restore: {},
            saveAsImage: {},
          },
          right: '2%',
        },
        grid: { left: 62, right: 20, top: 38, bottom: 58, containLabel: true },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLabel: {
            rotate: 25,
            fontSize: 11,
            interval: labelInterval,
            hideOverlap: true,
            formatter: val => (val || '').substring(5, 16),
            margin: 8,
          },
        },
        yAxis: {
          type: 'value',
          name: 'mmol/L',
          min: val => Math.max(0, Math.floor(val.min) - 1),
          max: val => Math.ceil(val.max) + 1,
          nameLocation: 'end',
          nameGap: 12,
          nameTextStyle: {
            align: 'left',
            padding: [0, 0, 0, -28],
          },
          axisLabel: { formatter: '{value}' },
          splitLine: { show: true },
        },
        dataZoom: [
          { type: 'inside', start: 0, end: 100 },
          { type: 'slider', start: 0, end: 100, height: 18, bottom: 6 },
        ],
        series: [
          {
            name: '血糖值',
            type: 'line',
            data: valueList,
            symbol: 'none',
            lineStyle: { color: '#4da1eb', width: 2 },
            itemStyle: { color: '#4da1eb' },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(77,161,235,0.28)' },
                  { offset: 1, color: 'rgba(77,161,235,0.02)' },
                ],
              },
            },
            // markLine: {
            //   silent: true,
            //   lineStyle: { color: '#F56C6C', type: 'dashed' },
            //   data: [
            //     { yAxis: 3.0, name: '2级低糖阈值', label: { position: 'insideEndBottom' } },
            //     { yAxis: 3.9, name: '达标下限', label: { position: 'insideEndTop' } },
            //     { yAxis: 10.0, name: '达标上限', label: { position: 'insideEndTop' } },
            //     { yAxis: 13.9, name: '2级高糖阈值', label: { position: 'insideEndTop' } },
            //   ],
            //   label: {
            //     formatter: '{b}',
            //     position: 'insideEndTop',
            //     color: '#606266',
            //     distance: 8,
            //     padding: [2, 4],
            //     backgroundColor: 'rgba(255,255,255,0.8)',
            //   },
            // },
          },
        ],
      };

      this.glucoseChart.setOption(option);
      this.bindResize();
    },
    drawRangeChart() {
      const dom = document.getElementById('rangeChart');
      if (!dom) return;
      if (this.rangeChart) this.rangeChart.dispose();
      this.rangeChart = this.$echarts.init(dom);

      const report = this.report || {};
      const data = [
        { name: '达标(TIR)', value: Number(report.tir) || 0, itemStyle: { color: '#67C23A' } },
        { name: '1级高血糖', value: Number(report.tar1) || 0, itemStyle: { color: '#E6A23C' } },
        { name: '2级高血糖', value: Number(report.tar2) || 0, itemStyle: { color: '#F56C6C' } },
        { name: '1级低血糖', value: Number(report.tbr1) || 0, itemStyle: { color: '#4da1eb' } },
        { name: '2级低血糖', value: Number(report.tbr2) || 0, itemStyle: { color: '#909399' } },
      ];

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const p = params[0];
            return `${p.name}：${p.value}%`;
          },
        },
        grid: { left: 80, right: 25, top: 20, bottom: 35 },
        xAxis: {
          type: 'value',
          max: 100,
          axisLabel: { formatter: '{value}%' },
        },
        yAxis: {
          type: 'category',
          data: data.map(item => item.name),
        },
        series: [
          {
            name: '占比',
            type: 'bar',
            data,
            barWidth: 18,
            label: {
              show: true,
              position: 'right',
              formatter: '{c}%',
            },
          },
        ],
      };

      this.rangeChart.setOption(option);
      this.bindResize();
    },
    bindResize() {
      if (this.resizeHandler) return;
      this.resizeHandler = () => {
        if (this.glucoseChart) this.glucoseChart.resize();
        if (this.rangeChart) this.rangeChart.resize();
      };
      window.addEventListener('resize', this.resizeHandler);
    },
    openReport() {
      if (this.report && this.report.filePath) {
        window.open(this.report.filePath, '_blank');
      }
    },
    getinfo() {
      this.$http({
        url: this.$http.adornUrl('/personal/info/getBasicInfo'),
        method: 'get',
        params: this.$http.adornParams({ uid: this.uid }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.realName = data.realName;
          this.gender = data.gender;
          this.age = data.age;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.uid = this.$route.query.uid;
    this.time = this.$route.query.RecordCreatetime;
    this.totalTime = this.$route.query.totalTime || '';
    this.routeRecord = {
      latestValue: this.$route.query.latestValue,
      avgValue: this.$route.query.avgValue,
      minValue: this.$route.query.minValue,
      maxValue: this.$route.query.maxValue,
      sampleCount: this.$route.query.sampleCount,
      status: this.$route.query.status,
      deviceSn: this.$route.query.deviceSn,
      theDay: this.$route.query.theDay,
    };
  },
  mounted() {
    this.getinfo();
    this.getDetail();
    this.getReport();
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.glucoseChart) this.glucoseChart.dispose();
    if (this.rangeChart) this.rangeChart.dispose();
  },
};
</script>

<style scoped>
.blank {
  border-radius: 4px;
  height: 18px;
}

.stat-card {
  border-radius: 8px;
  padding: 12px 12px;
  text-align: center;
  border: 1px solid #ebeef5;
  min-height: 96px;
}

.glucose-card {
  background: linear-gradient(135deg, #e8f4fd, #d0e8f9);
  border-color: #4da1eb;
}

.range-card {
  background: linear-gradient(135deg, #e8f8e8, #d0f0d0);
  border-color: #67C23A;
}

.tir-card {
  background: linear-gradient(135deg, #fdf6e8, #f9ecd0);
  border-color: #E6A23C;
}

.device-card {
  background: linear-gradient(135deg, #f4f4f5, #e9e9eb);
  border-color: #909399;
}

.stat-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}

.stat-main {
  font-size: 30px;
  font-weight: bold;
  color: #333;
  line-height: 1.2;
}

.status-main {
  font-size: 24px;
  line-height: 38px;
}

.stat-unit {
  font-size: 13px;
  font-weight: normal;
  color: #666;
  margin-left: 4px;
}

.stat-sub {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.report-info {
  margin-top: 12px;
  padding: 10px 0;
  text-align: left;
  font-size: 14px;
  color: #666;
  border-top: 1px solid #ebeef5;
}
</style>
